import { Database, QrCode, Users, ArrowRight } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: <Database size={26} />,
    title: "Data Collection & Digital Profile Creation",
    desc: "Manufacturers create a unique digital ID for each product. It securely links to all product data stored in the cloud.",
  },
  {
    number: "02",
    icon: <QrCode size={26} />,
    title: "Physical Tagging & Connection",
    desc: "A scannable QR code is securely affixed to each physical product, establishing a direct connection to its comprehensive and verified digital record in the cloud.",
  },
  {
    number: "03",
    icon: <Users size={26} />,
    title: "Access & Lifecycle Tracking",
    desc: "All stakeholders easily access relevant product data by simply scanning the code, ensuring complete visibility throughout the entire journey from production to final delivery.",
  },
];

function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 text-center">

        <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-medium">
          Simple Process
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-6">
          How Provinyx Works
        </h2>

        <p className="text-gray-500 mt-6 max-w-3xl mx-auto text-lg leading-relaxed">
          Consumers access individual product digital passports by scanning physical markers.
          Each product must have a unique identifier per EU DPP legislation.
        </p>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 mt-20 relative">

          {/* Connector lines (desktop only) */}
          <div className="hidden md:block absolute top-12 left-[33%] right-[33%] h-0.5 z-0" />

          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="group bg-[#ffff] p-8 rounded-2xl border border-gray-200 hover:border-blue-500 hover:bg-white hover:shadow-xl hover:-translate-y-2 transition-all duration-300 text-left cursor-pointer relative z-10">

                {/* Number badge */}
                <div className="absolute -top-5 left-8 bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center text-sm font-bold shadow-lg">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-12 h-12 bg-blue-100 text-blue-600 flex items-center justify-center rounded-xl mb-5 mt-6 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300">
                  {step.icon}
                </div>

                <h3 className="text-xl font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                  {step.title}
                </h3>

                <p className="text-gray-500 mt-3 leading-relaxed text-sm">
                  {step.desc}
                </p>
              </div>
 
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
